// extracted by mini-css-extract-plugin
module.exports = {"profile-information-lane":"Informations_profile-information-lane__1SFIq","profile-information-lane-span":"Informations_profile-information-lane-span__1rjhJ"};